import styled from 'styled-components';

export const HeaderContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;
